import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLang = localStorage.getItem("language_dir") || "en";

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: savedLang, // ✅ load from localStorage
    resources: {
      en: {
        translations: require("./i18n/locales/en/translations.json"),
      },
      bn: {
        translations: require("./i18n/locales/bn/translations.json"),
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

i18n.languages = ["en", "bn"];

export default i18n;
